import vue from 'vue';
import vuex from 'vuex';

vue.use(vuex);

// const modulesFiles = require.context('./modules', true, /\.js$/);
// const modules = modulesFiles.keys().reduce((files, modulePath) => {
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
//   const value = modulesFiles(modulePath);
//   return {
//     ...files,
//     [moduleName]: value.default,
//   };
// }, {});

// export default new vuex.Store({
//   modules,
//   plugins: [], // 开发环境下显示vuex的状态修改
// });

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default new vuex.Store({
  state,
  getters,
  mutations,
  actions
});
